import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { hashHistory, Link } from 'react-router';
import { Alert, Row, Col, Well } from 'react-bootstrap';
import Login from './Login';
import rms from './data/regionalleiter.json';


export default createReactClass({

   propTypes: {
      onChange: PropTypes.func,
      username: PropTypes.string,
      password: PropTypes.string,
   },

   getDefaultProps() {
      return {
         onChange() {},
         username: null,
         password: null,
      };
   },

   getInitialState() {
      return {
         paths: null,
         changeAccount: false,
         canRm: rms.includes(this.props.username),
         isRm: /\w+_rm$/.test(this.props.username),
         error: null,
      };
   },

   componentWillMount() {
      this.gatherPermissions();
   },

   gatherPermissions() {
      window.xnat.getProjects()
         .then((projects) => {
            const { lab, rev } = _.countBy(projects, p => p.data.project.slice(0, 3)); // die ersten drei Buchstaben des Projektnamens kodieren die Art
            const paths = [];

            // Regionalleiter werden gesondert behandelt, darum hier Abbruch
            if (this.state.isRm) return;

            if (rev === 1) { paths.push(['cases', 'Reviewer']); } // Reviewer
            if (rev > 1) { paths.push(['planning', 'QM-Manager']); } // QM-Manager
            if (lab) { paths.push(['labs', 'Schlaflaborleiter']); } // Schlaflaborleiter

            // Wenn nur ein möglicher Pfad vorhanden ist (und kein Regionalleiter), leite direkt dahin weiter.
            if (paths.length === 1 && !this.state.canRm) {
               hashHistory.push(paths[0][0]);
               return;
            }
            this.setState({ paths });
         })
         .catch(error => this.setState({ error: error.toString() }));
   },

   changeAccount(evt) {
      evt.preventDefault();
      this.setState({ changeAccount: true });
   },

   changeToRm() {
      const rmName = `${this.props.username}_rm`;
      const onLogin = (username, password) => {
         this.setState({
            changeAccount: false,
            canRm: false,
            isRm: true,
         });
         this.props.onChange(username, password);
         hashHistory.push('labs');
      };

      return (
         <Login
            autologin
            passwordOnly
            onLogin={onLogin}
            username={rmName}
            password={this.props.password}
         />
      );
   },

   changeFromRm() {
      const origName = this.props.username.replace(/_rm$/, '');
      const onLogin = (username, password) => {
         this.setState({
            changeAccount: false,
            paths: null,
            canRm: true,
            isRm: false,
         });
         this.props.onChange(username, password);
         this.gatherPermissions();
      };

      return (
         <Login
            autologin
            passwordOnly
            onLogin={onLogin}
            username={origName}
            password={this.props.password}
         />
      );
   },

   render() {
      if (this.state.error) {
         return (
            <Alert bsStyle="danger" className="centered-panel">
               <h4>Es ist ein Fehler aufgetreten.</h4>
               {this.state.error === 'Forbidden'
                  ? <p>Anscheinend ist Ihnen aktuell keine Rolle zugeordnet.</p>
                  : <p>Es ist folgender Fehler aufgetreten: "{this.state.error}".</p>
               }
               <p>Bitte sprechen Sie mit der QM-Leitung oder nutzen Sie den Button rechts unten, um den Fehler zu melden.</p>
            </Alert>
         );
      }

      if (this.state.changeAccount) {
         return this.state.isRm ? this.changeFromRm() : this.changeToRm();
      }

      if (this.state.isRm) {
         return (
            <Col md={12} key="rm">
               <Well className="text-center">
                  <a onClick={this.changeAccount} href="#/" className="huge block">Als Regionalleiter abmelden</a>
               </Well>
            </Col>
         );
      }

      if (this.state.paths == null) {
         return <h1 className="loading">Lade Berechtigungen</h1>;
      }

      if (_.isEmpty(this.state.paths)) {
         return <h1>Keine Berechtigungen gefunden</h1>;
      }

      return (
         <Row>
            {this.state.paths.map(path =>
               <Col md={4} key={path}>
                  <Well className="text-center">
                     <Link to={`/${path[0]}`} className="huge block">{path[1]}</Link>
                  </Well>
               </Col>
            )}
            {this.state.canRm &&
               <Col md={4} key="rm">
                  <Well className="text-center">
                     <a onClick={this.changeAccount} href="#/" className="huge block">Regionalleiter</a>
                  </Well>
               </Col>
            }
         </Row>
      );
   },

});
